<!-- Usage <MultiSelectionList caption="Sample Select" items="itemList" @add="addItem" @remove="removeItem"/> -->
<!-- Item list passed to this should contain objects in the form of {name:"Example Name", selected:false} -->

<template>
  <div class="select">
    <p class="caption">{{ caption }}</p>
    <div style="position:relative; width:90%">
      <input type="text" class="search" placeholder="Search" v-model="search" />
      <div class="list-container mt-30">
        <div
          v-for="(item, index) in reactiveItems"
          :key="index"
          @click="itemClick(index, $event)"
        >
          <p
            class="list-item"
            :style="{ backgroundColor: item.selected ? '#ededed' : 'white' }"
          >
            {{ item.name }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    caption: String,
  },

  data() {
    return {
      prevIndex: 0,
      search: "",
    };
  },

  computed: {
    reactiveItems() {
      return !this.search
        ? this.items
        : this.items.filter((x) =>
            x.name.toLowerCase().includes(this.search.toLowerCase())
          );
    },
  },

  methods: {
    itemClick(index, event) {
      let shiftHeld = event.shiftKey;
      if (shiftHeld) {
        this.selectMultiple(index);
      } else {
        this.prevIndex = index;

        if (this.reactiveItems[index].selected) {
          this.$emit("remove", this.reactiveItems[index].name);
        } else {
          this.$emit("add", this.reactiveItems[index].name);
        }
        this.reactiveItems[index].selected =
          !this.reactiveItems[index].selected;
      }
    },

    selectMultiple(index) {
      let start = Math.min(index, this.prevIndex);
      let end = Math.max(index, this.prevIndex) + 1;

      let selecting = this.reactiveItems[start].selected;

      for (let i = start; i < end; i++) {
        if (selecting) {
          if (!this.reactiveItems[i].selected) {
            this.$emit("add", this.reactiveItems[i].name);
            this.reactiveItems[i].selected = true;
          }
        } else {
          if (this.reactiveItems[i].selected) {
            this.$emit("remove", this.reactiveItems[i].name);
            this.reactiveItems[i].selected = false;
          }
        }
      }
    },
  },
};
</script>

<style scoped>
p {
  margin: 0;
  padding: 0;
}

.select {
  display: flex;
  width: 100%;
  min-width: 400px;
}

.caption {
  width: 50%;
}

.list-container {
  display: flex;
  flex-direction: column;
  min-width: 300px;
  max-height: 150px;
  overflow-y: scroll;
  border: 1px solid grey;
  border-radius: 6px;
  position: relative;
}

.list-item {
  padding: 5px;
  cursor: pointer;
  box-sizing: border-box;
}

.search {
  padding: 5px;
  height: 30px;
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  z-index:2;
}

.mt-30 {
  margin-top: 27px;
}
</style>